import { Component, OnInit } from '@angular/core';
import { RetirementPlanDocumentsService } from './service/retirement-plan-documents.service';
import { ProcessedDistribution } from 'client/app/domains/ProcessedDistribution';
import { Organization } from 'client/app/domains/Organization';
import { PageEvent } from '@angular/material/paginator';
import { trigger, state, style } from '@angular/animations';
import { EnumCacheKeys, GemsService } from 'client/app/shared';
import { concatMap } from 'rxjs/operators';
import { each, filter, sortBy } from 'lodash';

@Component({
  selector: 'app-retirement-plan-documents',
  templateUrl: './retirement-plan-documents.component.html',
  styleUrls: ['./retirement-plan-documents.component.less'],
  animations: [
    trigger('openClose', [
      state('open', style({
        display: '*'
      })),
      state('closed', style({
        display: 'none'
      }))
    ]),
  ],
  standalone: false
})

export class RetirementPlanDocumentsComponent implements OnInit {

  sort: Sort = { active: null, direction: '' };
  processedDistributionsLength: number;
  processedDistributions: ProcessedDistribution[];
  processedDistributionsSorted: ProcessedDistribution[];
  organizations: Organization[];
  processedDistributionsColumns = ['Organization', 'PlanDocument', 'Type', 'EffectiveDateDisplay', 'Status'];
  adoptionAgreementColumns = ['PlanDocument', 'Type', 'EffectiveDateDisplay', 'PlanNumber', 'Status'];
  retirementSpdColumns = ['PlanDocument', 'EffectiveDateDisplay'];
  safeHarborColumns = ['PlanDocument', 'EffectiveDateDisplay', 'ReleaseDate'];
  pageSize = 20;
  pageIndex = 0;
  pageEvent: PageEvent;
  sortDirection: string;
  sortActive: string;
  collectionsForSorting: any[] = [];
  isOpen: any[] = [];
  documentsLoading = true;
  matchPattern = 'admin/retirement-plan-documents';
  currentPageName = '';

  //Content
  retirementPlanDocumentsManagedContent: any;
  adoptionAgreementDownloadHelpText: any;
  addendumDownloadHelpText: any;
  manualUploadExplanation: any;
  radioButtonErrorMessage: any;
  globalCallouts: any;
  baSubmitInstructions: any;
  pageIntro: any;

  constructor(
    private retirementPlanDocumentsService: RetirementPlanDocumentsService,
    private gemsService: GemsService
  ) { }

  ngOnInit(): void {
    this.gemsService.loadContent('RetirementPlanDocuments', EnumCacheKeys.Help_RetirementPlanDocuments).subscribe((res: any) => {
      const content = res;
      this.retirementPlanDocumentsManagedContent = content;
      this.adoptionAgreementDownloadHelpText = filter(content.contents, { contentid: 'BA_AdoptionAgreement_Download' })[0].content;
      this.addendumDownloadHelpText = filter(content.contents, { contentid: 'BA_Addendum_Download' })[0].content;
      this.manualUploadExplanation = filter(content.contents, { contentid: 'BA_ManualUpload_Explanation' })[0].content;
      this.radioButtonErrorMessage = filter(content.contents, { contentid: 'BA_RadioButton_ErrorMessage' })[0].content;
      this.baSubmitInstructions = filter(content.contents, { contentid: 'BA_Retirement_Submit_Instructions' })[0].content;
      this.globalCallouts = filter(content.contents, { contentid: 'globalCallouts' })[0];
      const introContents = filter(content.contents, (ct: any) => {
        return ct.contentid === 'intro';
      });
      this.pageIntro = introContents[0].contents[0].description;
    });

    this.gemsService.getUser().pipe(
      concatMap(user => this.retirementPlanDocumentsService.loadData(user.person_id))
    ).subscribe(
      (data: any) => {
        this.processedDistributions = sortBy(data.ProcessedDistributions, ['Organization', 'PlanDocument']);
        this.organizations = data.Organizations;
        this.processedDistributionsLength = data.ProcessedDistributions.length;
        this.processedDistributionsSorted = sortBy(this.processedDistributions.slice(0, this.pageSize), ['Organization', 'PlanDocument']);

        for (let organization of data.Organizations) {
          const i = data.Organizations.indexOf(organization);
          this.collectionsForSorting["adoptionagreements" + i] = sortBy(organization.AdoptionAgreementDocuments, ['PlanDocument']);
          this.collectionsForSorting["adoptionagreementssorted" + i] = sortBy(organization.AdoptionAgreementDocuments, ['PlanDocument']);
          this.collectionsForSorting["safeharbors" + i] = sortBy(organization.SafeHarborDocuments, ['Type']);
          this.collectionsForSorting["pendingsmmacknowledgements" + i] = sortBy(organization.PendingSmmAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingspdacknowledgements" + i] = sortBy(organization.PendingSpdAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingshacknowledgements" + i] = sortBy(organization.PendingShAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["safeharborssorted" + i] = sortBy(organization.SafeHarborDocuments, ['Type']);
          this.collectionsForSorting["retirementspds" + i] = sortBy(organization.RetirementSpds, ['PlanType']);
          this.collectionsForSorting["retirementspdssorted" + i] = sortBy(organization.RetirementSpds, ['PlanType']);
          this.collectionsForSorting["pendingsmmacknowledgementssorted" + i] = sortBy(organization.PendingSmmAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingspdacknowledgementssorted" + i] = sortBy(organization.PendingSpdAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingshacknowledgementssorted" + i] = sortBy(organization.PendingShAcknowledgements, ['PlanDocument']);
          this.isOpen["adoptionagreementssorted" + i] = false;
          this.isOpen["safeharborssorted" + i] = false;
          this.isOpen["retirementspdssorted" + i] = false;
          this.isOpen["pendingsmmacknowledgementssorted" + i] = false;
          this.isOpen["pendingspdacknowledgementssorted" + i] = false;
          this.isOpen["pendingshacknowledgementssorted" + i] = false;
        }

        this.documentsLoading = false;
      });
  }

  toggle(hidden) {
    this.isOpen[hidden] = !this.isOpen[hidden];
  }

  // closeOthersDistribution(index, closeAll) {
  //   each(this.organizations, function(organization) {
  //     organization.PendingSpdAcknowledgements.open = false;
  //     organization.PendingSmmAcknowledgements.open = false;
  //     organization.PendingShAcknowledgements.open = false;
  //   });
  //   this.isOpen["pendingsmmacknowledgementssorted" + index] = closeAll;
  //   this.isOpen["pendingspdacknowledgementssorted" + index] = closeAll;
  //   this.isOpen["pendingshacknowledgementssorted" + index] = closeAll;
  //   }

  closeOthers(index, closeAll) {
    const that = this;
    each(this.organizations, function (organization, loopIndex) {
      const i = loopIndex;
      that.isOpen["adoptionagreementssorted" + i] = false;
      that.isOpen["safeharborssorted" + i] = false;
      that.isOpen["retirementspdssorted" + i] = false;
      each(organization.AdoptionAgreementDocuments, function (doc) {
        doc.AddendumsVisible = false;
      });
      each(organization.RetirementSpds, function (doc) {
        doc.SmmsVisible = false;
      });
    });

    this.isOpen["adoptionagreementssorted" + index] = closeAll;
    this.isOpen["safeharborssorted" + index] = closeAll;
    this.isOpen["retirementspdssorted" + index] = closeAll;
    each(this.collectionsForSorting["adoptionagreementssorted" + index], function (doc) {
      doc.AddendumsVisible = closeAll;
    });
  }

  sortDataAdoptionAgreements(sorting: Sort, i: number) {
    const data = this.collectionsForSorting["adoptionagreements" + i].slice();
    if (!sorting.active || sorting.direction === '') {
      this.collectionsForSorting["adoptionagreementssorted" + i] = data.slice();
      return;
    }

    this.collectionsForSorting["adoptionagreementssorted" + i] = data.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'PlanDocument': return compare(a.PlanDocument, b.PlanDocument, isAsc);
        case 'DocumentType': return compare(a.DocumentType, b.DocumentType, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        case 'PlanNumber': return compare(a.PlanNumber, b.PlanNumber, isAsc);
        default: return 0;
      }
    });
  }

  sortDataSafeHarborDocuments(sorting: Sort, i: number) {
    const data = this.collectionsForSorting["safeharbors" + i].slice();
    if (!sorting.active || sorting.direction === '') {
      this.collectionsForSorting["safeharborssorted" + i] = data.slice();
      return;
    }

    this.collectionsForSorting["safeharborssorted" + i] = data.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'Name': return compare(a.Name, b.Name, isAsc);
        case 'EffectiveDate': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        case 'ReleaseDate': return compare(a.ReleaseDate, b.ReleaseDate, isAsc);
        default: return 0;
      }
    });
  }

  sortDataRetirementSpds(sorting: Sort, i: number) {
    const data = this.collectionsForSorting["retirementspds" + i].slice();
    if (!sorting.active || sorting.direction === '') {
      this.collectionsForSorting["retirementspdssorted" + i] = data.slice();
      return;
    }

    this.collectionsForSorting["retirementspdssorted" + i] = data.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'PlanDocument': return compare(a.PlanType, b.PlanType, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        default: return 0;
      }
    });
  }

  sortDataProcessedDistributions(sorting: Sort) {
    this.sort = sorting;

    const data = this.processedDistributions.slice();
    if (!sorting.active || sorting.direction === '') {
      this.processedDistributionsSorted = data.slice((this.pageIndex * this.pageSize), (this.pageIndex + 1) * this.pageSize);
      return;
    }

    this.processedDistributionsSorted = data.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'Organization': return compare(a.Organization, b.Organization, isAsc);
        case 'PlanDocument': return compare(a.PlanDocument, b.PlanDocument, isAsc);
        case 'Type': return compare(a.Type, b.Type, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        default: return 0;
      }
    }).slice((this.pageIndex * this.pageSize), (this.pageIndex + 1) * this.pageSize);
  }

  pageData(pageEvent: PageEvent) {
    this.pageIndex = pageEvent.pageIndex;
    this.sortDataProcessedDistributions(this.sort);
  }

  docAcknowledged(docType: string) {
    this.ngOnInit();
  }
}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export class Sort {
  public direction: string;
  public active: string;
}

